<template>
  <div class="vh-100 bg-grey">
    <!-- HEADER -->
    <div class="header-top bg-white">
      <!-- Normal Header -->
      <div class="fixed-judul fixed-top">
        <div
          class="row justify-content-center align-items-center set-row w-limit"
        >
          <div class="col-md-2 col-sm-2 col-2 remove-padding">
            <div @click="RouteToDashboard">
              <div class="header-icon icon-arrow-left"></div>
            </div>
          </div>
          <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
            <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">
              Rincian Pendapatan
            </h6>
          </div>
          <div data-v-8dbe3aee="" class="col-md-2 col-sm-2 col-2"></div>
        </div>
      </div>
    </div>

    <!-- MAIN NORMAL CONTENT -->
    <main class="page-wrapper main-page w-limit">
      <div>
        <div class="main-content-data">
          <a
            class="f-16 f-semi f-c-blue dropdown-toggle"
            href="#"
            data-toggle="dropdown"
          >
            Pendapatan {{ status_text_data }}
          </a>
          <div class="dropdown-menu mod">
            <div class="dropdown-item plain">Konvensional:</div>
            <a id="kiloan" @click="filterData('kiloan')" class="dropdown-item"
              >Kiloan</a
            >
            <a id="satuan" @click="filterData('satuan')" class="dropdown-item"
              >Satuan</a
            >
            <a id="luas" @click="filterData('luas')" class="dropdown-item"
              >Luas</a
            >
            <a id="koin" @click="filterData('koin')" class="dropdown-item"
              >Koin</a
            >
            <div class="dropdown-item plain">SnapClean:</div>
            <a
              id="selfservice"
              @click="filterData('selfservice')"
              class="dropdown-item"
              >Self Service</a
            >
            <a id="dropoff" @click="filterData('dropoff')" class="dropdown-item"
              >Drop Off</a
            >
          </div>

          <div class="main-content">
            <div class="f-16 f-semi f-c-midgrey m-t-10">
              Total
              <span class="f-bold f-c-black" v-if="satuanGlobal == 'M2'"
                >{{ totalHarga | currency }} / {{ totalSatuan }} M<sup>2</sup>
              </span>
              <span class="f-bold f-c-black" v-else
                >{{ totalHarga | currency }} /
                {{ totalSatuan + " " + satuanGlobal }}
              </span>
            </div>
            <div class="f-14 f-c-midgrey m-t-8">{{ periode }}</div>
            <div class="list-card">
              <div class="flex-1">
                <div class="set-card" v-for="data in dataListRincian">
                  <div class="row add-padding-default">
                    <div
                      class="col-md-3 col-sm-3 col-3 remove-margin remove-padding"
                    >
                      <figure class="box">
                        <img
                          v-if="data.logo_outlet != ''"
                          v-bind:src="data.logo_outlet"
                          alt=""
                          style="
                            width: 48px;
                            border: 1px solid #e1e5ec;
                            box-sizing: border-box;
                            border-radius: 3px;
                          "
                        />
                        <img
                          v-else
                          src="../../assets/gambar/Rectangle43.svg"
                          alt=""
                          style="
                            width: 48px;
                            border: 1px solid #e1e5ec;
                            box-sizing: border-box;
                            border-radius: 3px;
                          "
                        />
                      </figure>
                    </div>
                    <div class="col-md-8 col-sm-8 col-8 remove-padding">
                      <div
                        class="font-16 remove-margin font-weight-bold nomore"
                      >
                        {{ data.nama_outlet }}
                      </div>
                      <div
                        class="font-14 remove-margin f-c-midgrey m-t-4 nomore"
                      >
                        {{ data.total_omset | currency }}
                      </div>

                      <div
                        class="font-13 remove-margin f-c-midgrey nomore"
                        v-if="data.nama_satuan == 'M2'"
                      >
                        {{ data.jumlah_beli }} M<sup>2</sup>
                      </div>
                      <div
                        v-else
                        class="font-13 remove-margin f-c-midgrey nomore"
                      >
                        {{ data.jumlah_beli + " " + data.nama_satuan }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />
            </div>
          </div>
        </div>

        <div class="loader"></div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: "ListKasLaci",
  data() {
    return {
      jenisPeriode: "bulan_ini",
      dataListRincian: [],
      totalSatuan: 0,
      totalHarga: 0,
      periode: "",
      satuanGlobal: "",
      status_text_data: "",
      requestHeaders: {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      },
    };
  },
  mounted() {
    // this.getDataListJenisSatuan()
    $(".loader").hide();
  },
  methods: {
    toTop() {
      window.scrollTo(0, 0);
    },
    RouteToDashboard() {
      this.$emit("ToChildDashboard");
    },
    FilterJenisSatuan(params, periode) {
      this.jenisPeriode = periode;
      this.getDataListJenisSatuan(params, periode);
      $(".main-content").hide();
    },
    filterData(params) {
      this.getDataListJenisSatuan(params, this.jenisPeriode);
      $(".main-content").hide();
    },
    async getDataListJenisSatuan(params, periods) {
      $(".dropdown-item").removeClass("active");
      $("#" + params).addClass("active");
      $(".loader").show();
      try {
        const response = await this.$axios.get(
          this.$baseurl +
            "/masterData/meta/detail_pendapatan_jenis_satuan?jenis_satuan=" +
            params +
            "&periode=" +
            periods,
          this.requestHeaders
        );
        if (response.data.code === 200) {
          if (response.data.status === true) {
            this.dataListRincian = [];
            this.totalHarga = 0;
            this.periode = response.data.data.periode;
            var eachData = response.data.data.result;
            var namaSatuan;
            switch (response.data.data.jenis_satuan) {
              case "kiloan":
                namaSatuan = "Kg";
                this.status_text_data = "Kiloan";
                break;
              case "luas":
                namaSatuan = "M2";
                this.status_text_data = "Luas";
                break;
              case "satuan":
                namaSatuan = "Satuan";
                this.status_text_data = "Satuan";
                break;
              case "koin":
                namaSatuan = "Koin";
                this.status_text_data = "Koin";
                break;
              case "selfservice":
                namaSatuan = "Nota";
                this.status_text_data = "Self Service";
                break;
              case "dropoff":
                namaSatuan = "Nota";
                this.status_text_data = "Drop Off";
                break;
              default:
                namaSatuan = "Satuan";
            }
            this.satuanGlobal = namaSatuan;
            var totalHargaSum = 0;
            var totalCountBeli = 0;

            for (let i = 0; i < eachData.length; i++) {
              var data = eachData[i];
              var urlSrcLogo;
              if (data.logo_outlet !== "" && data.logo_outlet !== null) {
                if (data.logo_outlet.includes("bos_revamp/")) {
                  urlSrcLogo =
                    "https://storage.googleapis.com/ember-e-dalbo/" +
                    data.logo_outlet;
                } else {
                  urlSrcLogo =
                    "https://res.cloudinary.com/sinadme/c_scale,h_200/" +
                    data.logo_outlet;
                }
              } else {
                urlSrcLogo = "";
              }

              totalHargaSum = totalHargaSum + data.total_omset;
              totalCountBeli = totalCountBeli + data.total_jumlah_beli;
              var jumlah = data.total_jumlah_beli.toFixed(2);
              if (this.satuanGlobal == "Nota") {
                jumlah = data.total_jumlah_beli;
              }
              this.dataListRincian.push({
                nama_outlet: data.nama_outlet,
                logo_outlet: urlSrcLogo,
                total_omset: data.total_omset,
                nama_satuan: namaSatuan,
                jumlah_beli: this.NumericFormat(jumlah, ""),
              });
            }

            this.totalHarga = totalHargaSum;
            $(".main-content").show();
            if (this.satuanGlobal == "Nota") {
              this.totalSatuan = totalCountBeli;
            } else {
              this.totalSatuan = this.NumericFormat(
                totalCountBeli.toFixed(2),
                ""
              );
            }
          } else {
            this.popupType = "error";
            this.popupMessage = response.data.msg;
          }
        } else {
          this.popupType = "error";
          this.popupMessage = response.data.msg;
        }
      } catch (e) {
        if (!e.code) {
          this.popupType = "error";
          this.popupErrorException = e;
        }
      }
      $(".loader").hide();
    },
    NumericFormat(num, prefix) {
      var str = num.toString().replace("", ""),
        parts = false,
        output = [],
        i = 1,
        formatted = null;
      var startStr = 0;
      if (str.indexOf("-") >= 0) {
        startStr = 1;
      }
      if (str.indexOf(".") >= 0) {
        parts = str.split(".");
        str = parts[0];
      }
      str = str.split("").reverse();
      var len = str.length;
      if (startStr == 1) {
        len = len - 1;
      }
      for (var j = 0; j < len; j++) {
        if (str[j] != ".") {
          if (j === len - 1 && startStr === 1) {
            var lenString = str.length;
            output.push(str[j]);
            output.push(str[lenString - 1]);
          } else {
            output.push(str[j]);
            if (i % 3 == 0 && j < len - 1) {
              output.push(".");
            }
            i++;
          }
        }
      }
      formatted = output.reverse().join("");
      return (
        prefix + " " + formatted + (parts ? "," + parts[1].substr(0, 2) : "")
      );
    },
  },
};
</script>
<style scoped>
.header-icon {
  height: 25px;
  width: 25px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.main-content-data {
  padding: 20px 20px;
}

.list-card {
  margin-top: 15px;
}
</style>
<style>
.loader {
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  border: 3px solid #ddd;
  border-top: 3px solid #aeb0b0;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin: 30% auto;
}

@-webkit-keyframes spin {
  to {
    border-top-color: #aeb0b0;
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    border-top-color: #aeb0b0;
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
